import { Flex } from "@radix-ui/themes";

export function InteractionViewNavbar() {
  return <Flex />;
}
